// @flow
import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RouteNames } from 'router';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { PageLoader } from 'components/molecules/pageLoader';
import FooterSection from 'components/templates/footer';
import PageTemplate from 'components/templates/pageTemplate';
import { StaticContentSection } from 'components/templates/staticContentSection';
import { useViewport } from 'components/templates/viewportProvider';
import type { AppState } from 'modules/rootReducer';
import type { SiteSettings, Vertical } from 'types/common';
import RenderSEO from 'components/atoms/renderSEO';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';

type Props = {
  isLoading: boolean,
  verticals: Array<Vertical>,
  getVerticals: () => void,
  siteSettings: SiteSettings,
  getSiteSettings: () => void,
};

const TermsPage = (props: Props) => {
  const {
    isLoading,
    getVerticals,
    verticals,
    getSiteSettings,
    siteSettings,
    getBannerData,
    getPageData,
    bannerData,
    cmsPageData,
    footerLink,
    getFooterLinkData,
  } = props;

  const metaTagSEO = {
    metaTitle: 'Disclaimer - Total Environment',
    metaDescription:
      'Total Environment Building Systems Private Limited (TEBS) makes all reasonable efforts to include accurate and up-to date information on this Website.',
    metaKeywords: '',
  };

  const { isMobile } = useViewport();
  let [theme, setTheme] = useState('light-theme');

  useEffect(() => {
    getVerticals();
    getSiteSettings();
    getBannerData();
    getPageData();
    getFooterLinkData();
  }, []);

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !siteSettings ||
    !footerLink ||
    !verticals ||
    !bannerData ||
    !cmsPageData
  ) {
    return null;
  }

  const componentList = [
    {
      component: StaticContentSection,
      data: { html: termsHTML, isScroll: false, toggleId: false },
      location: props,
      sectionId: 'terms',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Disclaimer',
          breadcrumbLink: RouteNames.terms,
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Disclaimer',
          breadcrumbLink: RouteNames.terms,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        showGetInTouch={false}
        showShareButton={false}
      />
    </>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading:
      HomeSelector.getVerticalsLoading(state) ||
      FooterSelector.isLoading(state) ||
      HomeSelector.getSiteSettingsLoading(state),
    verticals: HomeSelector.getVerticals(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    bannerData: HomeSelector.getBannerData(state),
    footerLink: FooterSelector.getFooterData(state),
    cmsPageData: CmsPagesSelector.getPageData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getVerticals, getSiteSettings, getBannerData } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getFooterLinkData } = FooterActions;
  return bindActionCreators(
    {
      getVerticals,
      getSiteSettings,
      getBannerData,
      getPageData,
      getFooterLinkData,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(TermsPage);

const termsHTML = `
<div>
  <h1>Disclaimer</h1>
    <div>
    <p>Total Environment Building Systems Private Limited (TEBS) makes all reasonable efforts to include accurate and up-to-date information on this website. However, TEBS does not make any warranties or representations, express or implied, as to the timeliness, accuracy or completeness of the information contained or referred to on its website and therefore, any advice or information received via this website should not be acted upon without consulting our sales team.</p>
    <p>Any access and use of this site is and will be at the risk of the User and neither TEBS nor its directors / employees shall be liable or responsible for any loss or damage arising directly or indirectly (including special, incidental or consequential loss or damage) from the use of this website howsoever arising, including due to any unavailability of the website or any part thereof or any contents or associated services or any computer viruses or technical bugs.</p>
    <p>References in this website to any products, features or services are to be read as statements of fact and not as their endorsement or recommendation by TEBS.</p>
    <p>It is the constant endeavour of TEBS to enhance the living experience of its residences and hence TEBS reserves the right to make any changes in any way, at any time and for any reason, without prior notice, to the contents and information on this site, including materials, equipment, specifications, prices and/or availability. It is clearly understood that dimensions and floor plan layouts are approximate and building illustrations are design concepts only. Images are for illustrative purpose only and view shots are representational and are not intended to reflect actual views from any particular unit.</p>
    <p>Except with specific prior permission of TEBS, any reproduction, retransmission, or other use of any information proprietary or otherwise on this site is strictly prohibited. Copyright in all the designs, plans, views shared on this website shall remain the property of TEBS and cannot to be used on any other work except by Agreement with TEBS.</p>
    <p>Any use of this website and any legal dispute arising in connection therewith shall exclusively be governed by Indian law and all arbitration shall fall within the jurisdiction of Bangalore Courts.</p>
  </div>
</div>
`;
